import {
  TOGGLE_MODAL_ORDER,
  SET_ATTACHED_GOODS,
  SET_LAST_GOOD
} from '../actionTypes';

export const controlModalOrder = value => async dispatch => {
  dispatch({
    type: TOGGLE_MODAL_ORDER,
    payload: value
  });
};

// obj {idGood:{attachGoodId: count, attachGoodId: count}, ...}
export const setAttachedGoods = obj => async dispatch => {
  dispatch({
    type: SET_ATTACHED_GOODS,
    payload: obj
  });
};

export const setLastGood = id => async dispatch => {
  dispatch({
    type: SET_LAST_GOOD,
    payload: id
  })
};
